import React, { Component, Fragment } from "react";
import _ from 'lodash'
import { connect } from "react-redux";

import getRights from "../../redux/action/rights";
import { bindActionCreators } from "redux";

class ListTable extends Component {
  state = {};
  componentWillMount() {
    const { tableHeaderData, tableRowData, editLink, viewLink } = this.props;

    this.setState({
      tableHeaderData,
      tableRowData,
      editLink,
      viewLink
    });
    this.props.getRights(this.props.moduleName);
  }
  // componentDidMount(nextProps){

  //   let accessCriteria = this.props.rights !== undefined && this.props.selectedRight !== undefined && this.props.rights[this.props.selectedRight.rightsName];
  //   this.setState({accessCriteria})
  // }
  componentWillReceiveProps(nextProps) {
    const { tableHeaderData, tableRowData, editLink, viewLink } = nextProps;
    let accessCriteria = nextProps.rights !== undefined && nextProps.selectedRight !== undefined && _.get(nextProps.rights, nextProps.selectedRight.rightsName.toString());
    this.setState({
      tableHeaderData,
      tableRowData,
      editLink,
      viewLink,
      accessCriteria
    });

  }

  render() {
    const { tableHeaderData, tableRowData, editLink, viewLink, accessCriteria } = this.state;
    const { deleteFunc, history, costingCompare } = this.props;
    return (
      <Fragment>
        <div class="col-md-12">
          {tableRowData && tableRowData.length > 0 ? (
            <div class="table-container fixed-height-list">
              <table class="striped list-table">
                <thead>
                  <tr>
                    {tableHeaderData.length > 0 &&
                      tableHeaderData.map((data, i) => {
                        return (
                          data.tableName !== "_id" && <th key={i} className={"position-top-stick"}>{data.tableName}</th>
                        );
                      })}
                    <th className="position-top-stick" colSpan="3" data-field="price">
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {tableRowData.map((data, index) => (
                    <tr key={index}>
                      {tableHeaderData.length > 0 &&
                        tableHeaderData.map(keyName => {
                          const leftAlignKeys = ["styleName", "magnumStyleName", "cust_Dept", "customer", "customerName", "custDept"];
                          const isLeftAlign = leftAlignKeys.includes(keyName.tableKeyName);
                          return keyName.tableKeyName !== "_id" ? (
                            data[keyName.tableKeyName] !== null ? (
                              data.fabricImage &&
                                keyName.tableKeyName == "fabricNumber" ? (
                                  <td>
                                    <ul className="list-inline nopadding">
                                      <li className="nopadding">
                                        <span>{data[keyName.tableKeyName]}</span>
                                      </li>
                                      <li className="nopadding">
                                        <span>
                                          <i className="material-icons fabric-image-icon">
                                            image
                                        </i>
                                        </span>
                                      </li>
                                    </ul>
                                  </td>
                                ) : (keyName.tableKeyName === 'RIGHTS' && (accessCriteria !== undefined && accessCriteria.web !== undefined && accessCriteria.web.create) && (this.props.moduleName == 'EMPLOYEE' || this.props.moduleName == 'ROLE')) ? (
                                  <td>
                                    <a class="linker cursor-hover" onClick={() => this.props.history.push("/employeRights", { _id: data._id, moduleName: this.props.moduleName })}>{"RIGHTS"}</a>
                                  </td>
                                ) : (
                                    <td className={`${typeof data[keyName.tableKeyName] == "boolean" ? "font-weight-bold" : ""} ${isLeftAlign ? "text-left" : ""}`}>
                                      {typeof data[keyName.tableKeyName] ==
                                        "boolean"
                                        ? data[keyName.tableKeyName] === true
                                          ? "active"
                                          : "inactive"
                                        : data[keyName.tableKeyName]}
                                    </td>
                                  )
                            ) : (
                                ""
                              )
                          ) : (
                              ""
                            );
                        })}
                      {/* {keyName.tableKeyName === 'RIGHTS' && (accessCriteria !== undefined && accessCriteria.web !== undefined && accessCriteria.web.create) && (this.props.moduleName =='ROLE') &&
                        <td>
                          <a class="linker cursor-hover" onClick={() => this.props.history.push("/employeRights", { _id: data._id, moduleName: this.props.moduleName })}>{"RIGHTS"}</a>
                        </td>
                      } */}
                      {/* {accessCriteria !== undefined && accessCriteria.web !== undefined &&  accessCriteria.web.view &&  */}
                      <td>
                        {/* change to COSTING */}
                        {this.props.moduleName === "COSTING" && <span className="compare mr-1" onClick={() => costingCompare(data)}><i class="material-icons">view_list</i></span>}
                        {((accessCriteria !== undefined && accessCriteria.web !== undefined && accessCriteria.web.view)) && <span
                          className="view"
                          style={{ cursor: "pointer" }}
                          title="View cursor-hover"
                          onClick={() =>
                            this.props.moduleName == "SMVTHREAD" ?
                              history.push(viewLink, {
                                action: "view",
                                _id: data._id,
                                styleReferenceId: "",
                                smvId: data.smvId
                              })
                              :
                              viewLink === "/Sample" ||
                                viewLink === "/CostingPage" ||
                                viewLink === "/StylePage" ||
                                viewLink === "/employee" ||
                                viewLink === "/Trim" ||
                                viewLink === "/developmentFabric" ||
                                viewLink === "/developmentSourcing" ||
                                viewLink === "/system/Supplier" ||
                                viewLink === "/BNumber" ||
                                viewLink === "/developmentCad" ||
                                viewLink === "/CustomerPage" ||
                                viewLink === "/MeetingNote" ||
                                viewLink === "/permissionRole" ||
                                viewLink === "/technicalIssues"
                                ? history.push(viewLink, {
                                  hash: viewLink === "/StylePage" && `seleted${data.styleNo.split('-').join('')}`,
                                  action: "view",
                                  _id: data._id
                                })
                                //  history.push(`${viewLink === "/StylePage" ? `${data && data.styleNo ? `${viewLink}#seleted${data.styleNo.split('-').join('')}` : viewLink}` : viewLink}`, {
                                //   action: "view",
                                //   _id: data._id
                                // })
                                : history.push(`${viewLink}?${data._id}`)
                          }
                        >
                          <i class="material-icons">visibility</i>
                        </span>}

                      </td>
                      {/* } */}
                      {/* {accessCriteria !== undefined &&  accessCriteria.web !== undefined && accessCriteria.web.edit && */}
                      <td>
                        {((accessCriteria !== undefined && accessCriteria.web !== undefined && accessCriteria.web.edit)) && <span
                          onClick={() =>
                            (this.props.moduleName == "SMVTHREAD" || this.props.moduleName == "TECHNICALISSUES") ?
                              history.push(editLink, {
                                action: "edit",
                                _id: data._id,
                                styleReferenceId: "",
                                smvId: data.smvId
                              })
                              :
                              editLink === "/Sample" ||
                                editLink === "/CostingPage" ||
                                editLink === "/StylePage" ||
                                editLink === "/employee" ||
                                editLink === "/Trim" ||
                                editLink === "/developmentCad" ||
                                editLink === "/developmentFabric" ||
                                editLink === "/developmentSourcing" ||
                                editLink === "/system/Supplier" ||
                                editLink === "/BNumber" ||
                                editLink === "/CustomerPage" ||
                                editLink === "/MeetingNote" ||
                                editLink === "/permissionRole"
                                ? history.push(editLink, {
                                  action: "edit",
                                  hash: editLink === "/StylePage" && `seleted${data.styleNo.split('-').join('')}`,
                                  _id: data._id
                                })
                                : history.push(`${editLink}?${data._id}`)
                          }
                          class="edit cursor-hover"
                          style={{ cursor: "pointer" }}
                          title="Edit"
                        >
                          <i class="material-icons">create</i>
                        </span>}
                      </td>
                      {/* } */}
                      {/* {accessCriteria !== undefined && accessCriteria.web !== undefined &&  accessCriteria.web.delete && */}
                      <td>
                        {(accessCriteria !== undefined && accessCriteria.web !== undefined && accessCriteria.web.delete) && <span
                          onClick={() => deleteFunc(data._id)}
                          className="delete cursor-hover"
                          title="delete"
                        >
                          <i className="material-icons">delete</i>
                        </span>}
                      </td>
                      {/* } */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
              <div className="col-md-12 text-center p-5">
                <p> No Data Found </p>
              </div>
            )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    rights: state.main.rights,
    selectedRight: state.rights.rightsInfo
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    "getRights": getRights
  }, dispatch)
}

export default connect(
  mapStateToProps, mapDispatchToProps
)(ListTable);


// WEBPACK FOOTER //
// ./src/components/ListPage/ListTable.js